<template>
    <v-stage ref="stage" :config="stageSize">
        <v-layer ref="layer">
            <v-regular-polygon
                ref="hexagon"
                :config="{
                    x: 200,
                    y: 200,
                    sides: 6,
                    radius: 70,
                    fill: '',
                    stroke: 'black',
                    strokeWidth: 2
                }"
            />
        </v-layer>
    </v-stage>
</template>

<script>
const width = window.innerWidth;
const height = window.innerHeight;

export default {
    data() {
        return {
            stageSize: {
                width: width,
                height: height
            }
        };
    },
    mounted() {
        const vm = this;
        const amplitude = 100;
        const period = 1000;
        // in ms
        const centerX = vm.$refs.stage.getStage().getWidth() / 2;

        const hexagon = this.$refs.hexagon.getStage();

        // example of Konva.Animation

        let tween = hexagon.to({
            x : 50,
            duration : 0.5,
            onFinish: function() {
                console.log(this);
                
            }
        });

        // start tween after 2 seconds
    }
    };
</script>